(function() {
  const CollectionSort = {
    init: function() {
      this.sortItems = document.querySelectorAll('.sort-dropdown__item');
      this.sortButton = document.querySelector('.sort-dropdown__button');
      this.bindEvents();
    },

    bindEvents: function() {
      this.sortItems.forEach(item => {
        item.addEventListener('click', () => this.handleSort(item));
      });
    },

    handleSort: function(item) {
      const field = item.getAttribute('data-field');
      const url = new URL(window.location.href);
      
      url.searchParams.set('sort_by', field);
      
      if (this.sortButton) {
        this.sortButton.textContent = item.textContent.trim();
      }

      window.location.href = url.toString();
    }
  };

  document.addEventListener('DOMContentLoaded', () => {
    CollectionSort.init();
  });
})();